'use strict';

const { queryFirst, removeClass } = require('./domUtil');
const { tokenize } = require('./util');

/**
 * @description This file is used to initialize the agent header functionality
 *
*/
function initializeAgentHeader() {
    const agentInputContainer = queryFirst('#agentDataInput');
    const agentHtmlContainer = queryFirst('#agentHeader');
    // if data container and html markup exists - we will initialize the agent header functionality
    if (agentInputContainer && agentHtmlContainer) {
        // if the displayAgentHeader is set to true - we will display the agent header
        if (agentInputContainer.dataset?.displayAgentHeader === 'true') {
            // tokenize(longDescription, { lillyColor: lillyColorName }, '{{', '}}')
            const customerName = agentInputContainer.dataset?.customerName || '';
            const customerNo = agentInputContainer.dataset?.customerNo || '';
            const agentHeaderType = agentInputContainer.dataset?.agentHeaderType;
            const sessionUserName = agentInputContainer.dataset?.sessionUsername;

            agentHtmlContainer.innerHTML = tokenize(agentHtmlContainer.innerHTML, { customerName, customerNo, sessionUserName }, '{{', '}}');
            if (agentHeaderType === 'customer') {
                removeClass(queryFirst('.js-agent-customer'), 'd-none');
            } else if (agentHeaderType === 'anonymous') {
                removeClass(queryFirst('.js-agent-anonymous'), 'd-none');
            }
            // finally show the agent header html block
            removeClass(agentHtmlContainer, 'd-none');
        }
    }
}

initializeAgentHeader();
